import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import eventEmitter from "../../events/eventEmitter";
import api from "../../helper/api";
import { useSelector } from "react-redux";

const PlayModePopup = ({
  isOpen,
  onClose,
  onSelect,
  selectedGame,
  prefetchedData,
}) => {
  const { error: profileError, data: profileData } = useSelector(
    (state) => state.getProfile
  );
  const [step, setStep] = useState(1);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [userData, setUserData] = useState(prefetchedData || null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 768;

  const getUserData = async () => {
    try {
      setIsLoading(true);
      await api
        .post("/gift/get-risk-free-bets", {
          game_id: selectedGame?._id,
        })
        .then((res) => {
          setUserData(res?.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error("error: ", error);
    }
  };
  useEffect(() => {
    if (!profileData?.user) return;
    if (prefetchedData) {
      setUserData(prefetchedData);
      return;
    }
    if (isOpen) {
      getUserData();
    }
  }, [isOpen, prefetchedData]);

  const isKYCVerified =
    userData?.user?.is_kyc_verified == "verified" ? true : false;
  const giftWallet = userData?.user?.gift_wallet || 0;
  const cashWallet = userData?.user?.usable_coin_balance || 0;
  const hasRiskFreeBet = userData?.hasValidRiskFreeBet;
  useEffect(() => {
    console.log(61, isKYCVerified, prefetchedData)
    if(!isKYCVerified) {
      setStep(0);
      return;
    }
    if (prefetchedData) return; // Skip auto-logic if data is prefetched (parent logic handled it)

    if (isOpen && !isLoading) {
      if (!isKYCVerified) {
        setStep(0);
        return;
      }
      eventEmitter.emit("refreshUserData", userData);

      if (giftWallet == 0) {
        setSelectedWallet("cash");

        if (hasRiskFreeBet == false) {
          onSelect({ wallet: "cash", mode: "normal" });
          onClose();
        } else {
          setStep(2);
        }
      } else {
        setStep(1);
        setSelectedWallet(null);
      }
    }
  }, [
    isOpen,
    isLoading,
    userData,
    isKYCVerified,
    onClose,
    onSelect,
    prefetchedData,
  ]);

  const handleWalletSelect = (walletType) => {
    setSelectedWallet(walletType);

    if (hasRiskFreeBet == false) {
      onSelect({ wallet: walletType, mode: "normal" });
      setStep(1);
      onClose();
    } else {
      setStep(2);
    }
  };

  const handleFinalSelect = (mode) => {
    onSelect({ wallet: selectedWallet, mode });
    setStep(1);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={isOpen ? `modal d-block show-animate` : `modal`}>
      <div
        className="modal-dialog modal-dialog-centered mt-0"
        style={{ maxWidth: "45%" }}
      >
        <div className="modal-content modal-content-bg h-100 promotion-modal-readmore">
          <div className="modal-body p-1 p-md-3 text-center text-white fw-semibold scroll-y m-1 m-md-0">
            <div className="mt-5 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
              <div className="d-flex flex-wrap px-3 align-items-center justify-content-center">
                {/* Close Button */}
                <span
                  className="svg-icon svg-icon-1 cursor-pointer"
                  onClick={() => {
                    setStep(1);
                    setSelectedWallet(null);
                    onClose();
                  }}
                >
                  <RxCross2
                    size={25}
                    className="svg-icon cross-icon"
                    style={{
                      position: "absolute",
                      right: "25px",
                      top: "25px",
                    }}
                  />
                </span>

                {isLoading ? (
                  <div className="text-center" style={{ padding: "8% 0px" }}>
                    <div
                      className="spinner-border text-success"
                      role="status"
                    ></div>
                  </div>
                ) : (
                  <div className="play-popup">
                    {/* 🚫 Step 0 → KYC Not Verified */}
                    {step == 0 ? (
                      <>
                        <h3>KYC Verification Required</h3>
                        {userData?.user?.is_kyc_verified == "rejected" ? (
                          <p>
                            Your previous KYC submission was rejected. Please
                            resubmit your documents for verification.
                          </p>
                        ) : (
                          <p>
                            Your KYC verification is pending. Please complete
                            the verification to proceed. If already submitted
                            please wait for admin approval
                          </p>
                        )}

                        <div className="d-flex justify-content-center">
                          <button
                            className="btn btn-warning mt-3"
                            onClick={() => {
                              onClose();
                              navigate(
                                "/profile-dashboard/account-verification"
                              ); // 👈 redirect to KYC page
                            }}
                          >
                            Go to KYC Page
                          </button>
                        </div>
                      </>
                    ) : step == 1 ? (
                      <>
                        <h3>Select Wallet</h3>
                        <p>Choose your funding source</p>
                        <div
                          className={`popup-buttons ${
                            isMobile ? "flex-column" : ""
                          }`}
                        >
                          {giftWallet > 0 && (
                            <button
                              onClick={() => handleWalletSelect("gift")}
                              disabled={userData?.minBet > giftWallet}
                              style={{
                                cursor: `${
                                  userData?.minBet > giftWallet
                                    ? "not-allowed"
                                    : "pointer"
                                }`,
                              }}
                            >
                              <span
                                style={{
                                  color: `${
                                    userData?.minBet > giftWallet
                                      ? "#f1416c"
                                      : ""
                                  }`,
                                }}
                              >
                                🎁 Gift Wallet <br /> (
                                {new Intl.NumberFormat("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(giftWallet || 0)}
                                )
                              </span>
                            </button>
                          )}
                          <button onClick={() => handleWalletSelect("cash")}>
                            <span>
                              💰 Cash Balance <br /> (
                              {new Intl.NumberFormat("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(cashWallet || 0)}
                              )
                            </span>
                          </button>
                        </div>
                        {userData?.minBet > giftWallet && (
                          <p className="text-danger">
                            Note: Gift wallet usage is not allowed because the
                            minimum bet amount set by the admin exceeds your
                            gift wallet balance.{" "}
                          </p>
                        )}
                      </>
                    ) : selectedWallet ? (
                      <>
                        <h3>Select Bet Type</h3>
                        <p>Choose how you want to place your bet</p>
                        <div
                          className={`popup-buttons ${
                            isMobile ? "flex-column" : ""
                          }`}
                        >
                          <button onClick={() => handleFinalSelect("normal")}>
                            <span>🎯 Normal Bet</span>
                          </button>
                          {hasRiskFreeBet &&
                            selectedGame?.game_id != "550000" && (
                              <button
                                onClick={() =>
                                  handleFinalSelect("risk_free_bet")
                                }
                              >
                                <span>🛡️ Risk Free Bet</span>
                              </button>
                            )}
                          {giftWallet > 0 && (
                            <button
                              className="btn btn-secondary mt-3"
                              onClick={() => {
                                setStep(1);
                                setSelectedWallet(null);
                              }}
                            >
                              ← Back
                            </button>
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PlayModePopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  userData: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default PlayModePopup;
